<template>
	<el-container class="school">
		<el-aside width="180px">
			<nav-menu></nav-menu>
		</el-aside>
		<el-main class="content">
			<el-card class="screen-box">
				<el-form ref="searchForm" :model="searchForm" :inline="true" size="small">
					<el-form-item label="学校:" prop="name">
						<el-input v-model="searchForm.name" placeholder="请输入学校"></el-input>
					</el-form-item>
					<el-form-item>
						<el-button @click="search()" icon="el-icon-search" type="primary" size="small">查询</el-button>
						<el-button @click="resetForm()" icon="el-icon-delete" size="small">清空</el-button>
						<el-button @click="add()" icon="el-icon-plus" type="primary" size="small">添加学校信息</el-button>
					</el-form-item>
				</el-form>
			</el-card>
			<el-card class="table-box">
				<el-table :data="tableList" id="table" border>
					<el-table-column type="index" width="50"></el-table-column>
					<template v-for="(item, index) in tableLabel">
						<el-table-column :key="index" :prop="item.prop" :label="item.label" :formatter="item.formatter">
						</el-table-column>
					</template>
					<el-table-column label="操作" width="130">
						<template slot-scope="scope">
							<el-switch v-model="scope.row.isLoad" @change="switchChange(scope.row.isLoad,scope.row.id)"></el-switch>
							<el-button type="text" size="mini" @click="edit(scope.row)">编辑</el-button>
						</template>
					</el-table-column>
				</el-table>
				<el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange" :current-page="searchForm.page" :page-sizes="pageSizes" :page-size="searchForm.limit" layout="total, sizes, prev, pager, next, jumper" :total="totalCount"></el-pagination>
			</el-card>
		</el-main>
		<!-- 弹出层 -->
		<el-dialog :title="dialogTitle" :visible.sync="dialogFormVisible">
			<el-form :model="form" label-width="150px" size="small">
				<el-form-item label="学校">
					<el-input placeholder="请输入学校" v-model="form.name"></el-input>
				</el-form-item>
				<el-form-item label="学段编码">
					<el-select placeholder="请选择学段编码" v-model="form.periodCode">
						<el-option label="幼儿园" value="kindergarten "></el-option>
						<el-option label="小学" value="primary_school"></el-option>
						<el-option label="初中" value="middle_school"></el-option>
						<el-option label="高中" value="high_school"></el-option>
						<el-option label="技校/高校" value="college"></el-option>
					</el-select>
				</el-form-item>
				<el-form-item label="地址">
					<el-input placeholder="请输入地址" v-model="form.address"></el-input>
				</el-form-item>
				<el-form-item label="海康clientId">
					<el-input placeholder="请输入" v-model="form.hikProperties.clientId"></el-input>
				</el-form-item>
				<el-form-item label="海康clientSecret">
					<el-input placeholder="请输入" v-model="form.hikProperties.clientSecret"></el-input>
				</el-form-item>
				<el-form-item label="企微aesKey">
					<el-input placeholder="请输入" v-model="form.cpProperties.aesKey"></el-input>
				</el-form-item>
				<el-form-item label="企微agentCorpSecret">
					<el-input placeholder="请输入" v-model="form.cpProperties.agentCorpSecret"></el-input>
				</el-form-item>
				<el-form-item label="企微agentId">
					<el-input placeholder="请输入" v-model="form.cpProperties.agentId"></el-input>
				</el-form-item>
				<el-form-item label="企微corpId">
					<el-input placeholder="请输入" v-model="form.cpProperties.corpId"></el-input>
				</el-form-item>
				<el-form-item label="企微corpSecret">
					<el-input placeholder="请输入" v-model="form.cpProperties.corpSecret"></el-input>
				</el-form-item>
				<el-form-item label="企微token">
					<el-input placeholder="请输入" v-model="form.cpProperties.token"></el-input>
				</el-form-item>
			</el-form>
			<div slot="footer" class="dialog-footer">
				<el-button @click="dialogFormVisible = false" size="small">取 消</el-button>
				<el-button type="primary" @click="formSubmit()" size="small">确 定</el-button>
			</div>
		</el-dialog>
  	</el-container>
</template>

<script>
	import { schoolPageApi,schoolSaveApi,schoolSwitchApi,schoolUpdateApi } from "@/axios/api";
	export default {
		name: "School",
		data() {
			return {
				totalCount:0,
				pageSizes:[10],
				searchForm:{
					name: '',//学校名称
					isSearchCount:true,
					page:1,
					limit:10
				},
				tableList: [],
				tableLabel: [{
					label: "学校",
					prop: "name"
				}, {
					label: "学段编码",
					prop: "periodCode",
					formatter: (row) => {
						if(row.periodCode == 'kindergarten'){
							return '幼儿园'
						}else if(row.periodCode == 'primary_school'){
							return '小学'
						}else if(row.periodCode == 'middle_school'){
							return '初中'
						}else if(row.periodCode == 'high_school'){
							return '高中'
						}else if(row.periodCode == 'college'){
							return '技校/高校'
						}
					}
				}, {
					label: "地址",
					prop: "address"
				}, {
					label: "创建时间",
					prop: "createTime"
				}],
				dialogFormVisible: false,
				dialogTitle:'添加学校信息',
				form: {
					name:'',//学校名称
					periodCode:'',//学段编码
					address:'',//地址
					id:'',
					isLoad:false,
					createTime:'',
					updateTime:'',
					hikProperties:{//HIK配置信息
						clientId:'',
						clientSecret:''
					},
					cpProperties:{//CP配置信息
						aesKey:'',
						agentCorpSecret:'',
						agentId:'',
						corpId:'',
						corpSecret:'',
						token:''
					}
				},
				openType:''
			}
		},
		created(){
			this.getData();
		},
		methods:{
			getData(){
				schoolPageApi(this.searchForm).then((res) => {
					if (res.code == 200){
						this.tableList = res.data.records;
						this.totalCount = res.data.total;
					}
				}).catch((err) => {});
			},
			//查询
			search(){
				this.searchForm.page = 1;
				this.getData();
			},
			//清空
			resetForm(){
				this.searchForm.name = '';
				this.searchForm.page = 1;
				this.getData();
			},
			//添加学校信息
			add(){
				this.form = {
					name:'',
					periodCode:'',
					address:'',
					id:'',
					isLoad:false,
					createTime:'',
					updateTime:'',
					hikProperties:{
						clientId:'',
						clientSecret:''
					},
					cpProperties:{
						aesKey:'',
						agentCorpSecret:'',
						agentId:'',
						corpId:'',
						corpSecret:'',
						token:''
					}
				};
				this.openType = 'add';
				this.dialogTitle = '添加学校信息';
				this.dialogFormVisible = true;
			},
			//编辑
			edit(row){
				this.form = row;
				this.openType = 'edit';
				this.dialogTitle = '编辑学校信息';
				this.dialogFormVisible = true;
			},
			formSubmit(){
				if(this.openType == 'edit'){
					schoolUpdateApi(this.form).then((res) => {
						if (res.code == 200){
							this.$message.success("编辑成功");
							this.dialogFormVisible = false;
							this.getData();
						}
					}).catch((err) => {});
				}else{
					schoolSaveApi(this.form).then((res) => {
						if (res.code == 200){
							this.$message.error("添加成功");
							this.dialogFormVisible = false;
							this.searchForm.name = '';
							this.searchForm.page = 1;
							this.getData();
						}
					}).catch((err) => {});
				}
			},
			//开关负载
			switchChange(isLoad, id){
				schoolSwitchApi({id:id,isLoad:isLoad}).then((res) => {
					if (res.code == 200){
						this.getData();
					}
				}).catch((err) => {});
			},
			// 分页
			handleSizeChange(val) {
				this.searchForm.limit=val // 改变每页显示的条数 
				this.searchForm.page=1 // 注意：在改变每页显示的条数时，要将页码显示到第一页
				this.getData() // 点击每页显示的条数时，显示第一页
			},
			handleCurrentChange(val) {
				this.searchForm.page=val // 改变默认的页数
				this.getData() // 切换页码时，要获取每页显示的条数
			}
		}
	}
</script>

<style lang="less" scoped>
	/deep/.el-switch{
		margin-right: 8px;
	}
	.screen-box{
		margin-left: 12px;
	}
	.table-box{
		margin-left: 12px;
		min-height: 83vh;
	}
</style>
